import { Button, TextInput, Typography } from "@fullscript/aviary-web";
import type { ChangeEvent } from "react";
import { useTranslation } from "react-i18next";

import { useBreakpoints } from "@shared/hooks/useBreakpoints/useBreakpoints";
import { BackButton } from "@shared/layouts";
import { l } from "@shared/locales/i18n";

import * as styles from "./BackupCodeForm.styles";

interface Props {
  backupCode: string;
  errors: string[];
  onChange: (backupCode: string) => void;
  onSubmit: () => void;
  onResetErrors: () => void;
  onBackToSignIn?: () => void;
}

const BackupCodeForm = ({
  backupCode,
  errors,
  onChange,
  onSubmit,
  onResetErrors,
  onBackToSignIn,
}: Props) => {
  const { t } = useTranslation();
  const { phoneLarge } = useBreakpoints();

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    onResetErrors();
    onChange(e.target.value);
  };

  return (
    <form css={styles.wrapper} onSubmit={onSubmit}>
      <Typography as="h1" variant="h3">
        {t(l.mfa.backupCodeForm.title)}
      </Typography>
      <Typography>{t(l.mfa.backupCodeForm.subtitle)}</Typography>
      <div css={styles.backupCodeInputWrapper}>
        <TextInput
          id="backupCode"
          value={backupCode}
          onChange={handleChange}
          label={t(l.mfa.backupCode)}
          errorCaption={errors[0]}
          type="text"
          required
        />
      </div>
      <Button
        customCss={styles.nextButton}
        onClick={onSubmit}
        disabled={!backupCode}
        isFullWidth={phoneLarge.lessThan}
        variant="primary"
      >
        {t(l.sharedCommon.Next)}
      </Button>
      <BackButton
        text={t(l.mfa.VerifyMFAForm.backToSignIn)}
        onClick={onBackToSignIn}
        isUnderLined={false}
      />
    </form>
  );
};

export { BackupCodeForm };
